// extracted by mini-css-extract-plugin
export default {"user":"User_user__FhuPD","name":"User_name__7kX-P","isOnline":"User_isOnline__GbNKM"};